module.exports = __webpack_public_path__ + "static/media/Icons.7b274f97.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Icon/Icons.svg
// module id = 543
// module chunks = 32